<template>
  <div>
    <p class="master-name">
      {{ first_name }} {{ last_name }}
      Aufträge
    </p>

    <div
      class="master-comments"
      :style="{
        'max-height': maxHeight,
      }"
      @scroll="onScroll"
    >
      <div class="master-comment master-comment_head">
        <div class="master-comment__number">#</div>
        <div class="master-comment__service"></div>
        <div class="master-comment__date">
          {{ $t("listsHeader.date") }}
        </div>
        <div class="master-comment__source">
          {{ $t("forms.source") }}
        </div>
        <div class="master-comment__price">{{ $t("listsHeader.price") }}</div>
        <div class="master-comment__status">
          {{ $t("listsHeader.status") }}
        </div>
        <div class="master-comment__executors">
          {{ $t("navigation.masters") }}
        </div>
        <div class="master-comment__rate">{{ $t("forms.company") }}</div>
        <div class="master-comment__rate">{{ $t("forms.master") }}</div>
        <div class="master-comment__link">Bestelllink</div>
      </div>
      <div
        class="master-comment"
        v-for="(item, index) in requests"
        :key="item.id"
        @click="fetchOrder(item.id)"
      >
        <div class="master-comment__number">{{ index + 1 }}</div>
        <div class="master-comment__service">
          <img width="15px" height="15px" :src="item.service.icon" alt />
        </div>
        <div class="master-comment__date">
          {{ convertDate(item.should_started_at) }}
        </div>
        <div class="master-comment__source">
          <img
            :src="convertSource(item.source)"
            width="15px"
            height="15px"
            alt=""
          />
        </div>
        <div class="master-comment__price">€{{ item.final_price }}</div>
        <div class="master-comment__status">
          {{ localeOrderStatus(item.status) }}
        </div>
        <div class="master-comment__executors">
          <span v-for="executor in item.executors" :key="executor.id">
            {{ executor.first_name }} {{ executor.last_name }}
          </span>
        </div>
        <div class="master-comment__rate">
          <span v-if="item.rating">{{ item.rating.company_rating }}</span>
          <span v-else>-</span>
        </div>
        <div class="master-comment__rate">
          <span v-if="item.rating">{{ item.rating.master_rating }}</span>
          <span v-else>-</span>
        </div>
        <div class="master-comment__link">
          <button type="reset" @click="openOrder(item.id)">
            Auftrag öffnen
          </button>
        </div>
      </div>
    </div>

    <modal
      :show="showModal"
      @close="closeOrderModal"
      :dark="true"
      :outside="false"
    >
      <transition name="showmodal">
        <orders-modal @done="done" />
      </transition>
    </modal>
  </div>
</template>

<script>
import date from '@/mixins/date'
import locale from '@/utils/locale'
import source from '@/mixins/source'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import ordersModal from '@/components/modals/orders/ordersModal'

export default {
    name: 'user-requests',
    mixins: [date, locale, source],
    props: {
        requests: {
            required: true,
            type: Array,
        },
        first_name: {
            required: true,
            type: String,
        },
        last_name: {
            required: true,
            type: String,
        },
        maxHeight: {
            required: false,
            default: '530px',
        },
    },
    components: {
        ordersModal,
    },
    computed: {
        ...mapGetters({
            showModal: 'orders/showModal',
        }),
    },
    data() {
        return {
            isRiched: false,
        }
    },
    methods: {
        ...mapMutations({
            setToggleModalState: 'orders/setToggleModalState',
        }),
        ...mapActions({
            fetchOrder: 'orders/fetchById',
        }),
        done() {
            this.$emit('done')
        },
        async openOrder(id) {
            await this.fetchOrder(id)
            this.setToggleModalState(true)
        },
        closeOrderModal() {
            this.setToggleModalState(false)
        },
        onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (clientHeight + scrollTop + 30 > scrollHeight && !this.isRiched) {
                this.$emit('rich-bottom')
                this.isRiched = true

                setTimeout(() => {
                    this.isRiched = false
                }, 1000)
            }
        },
    },
    beforeDestroy() {
        this.setToggleModalState(false)
    },
}
</script>

<style lang="scss" scoped>
.master {
  &-name {
    // border-top: 1px solid lightgrey;
    // margin-top: 20px;
    // padding-top: 10px;
    margin-bottom: 10px;
    color: var(--menu-text-color);
    font-family: "archivo-medium";
    font-size: 18px;
    line-height: 29px;
  }

  &-comments {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  &-comment {
    display: flex;
    width: 100%;
    background-color: var(--hover-bg-color);
    color: var(--list-color);
    line-height: 15px;
    padding: 10px 0;
    font-size: 11px;

    &_head {
      font-weight: bold;
      background-color: var(--bg-color2);
      color: var(--label-color);

      .master-comment__number {
        font-size: 18px;
      }
    }

    // &:nth-child(odd) {
    //   background-color: #f8f5f5;
    // }

    &__number {
      width: 5%;
      text-align: center;
    }

    &__executors {
      width: 15%;
      display: flex;
      flex-direction: column;

      span {
        &:not(:first-child) {
          margin-top: 4px;
        }
      }
    }

    &__link {
      width: 10%;
      // color: var(--menu-text-color);

      button {
        text-decoration: underline;
        background-color: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
        color: var(--menu-text-color);
      }
    }

    &__rate {
      width: 8%;
      text-align: center;
    }

    &__comments {
      width: 70%;
      box-sizing: border-box;
      padding-left: 5%;
    }

    &__price {
      width: 7%;
      padding-left: 10px;
    }

    &__service {
      width: 5%;
      text-align: center;
    }

    &__source {
      width: 6%;
      text-align: center;
    }

    &__date {
      width: 10%;
      padding-left: 10px;
    }

    &__link {
      width: 20%;
    }

    &__status {
      width: 18%;
    }
  }
}
</style>
